(function () {
  'use strict';

  function describeSeries(input) {
    var raw = (input || '').trim();
    if (!raw || /^(?:-|–|—|n\/?a|none|stand[ -]?alone|not applicable)$/i.test(raw)) {
      return { name: 'Standalone Books', key: '__standalone__', number: null, supplementary: false };
    }

    var grouped = raw.match(/^(.*?)\s*[-–—:]\s*(?:(?:books?|volumes?|vols?\.?|parts?)\b|(?:companion|prequel|novella|short stories)\b)/i);
    var numericRange = raw.match(/^(.*?)\s+(\d+)\s*[-–]\s*(\d+)\s*$/);
    var name = grouped && grouped[1] ? grouped[1].trim() : numericRange ? numericRange[1].trim() : raw;
    var number = null;
    var numbered = raw.match(/\b(?:book|volume|vol\.?|part)\s*#?\s*(\d+(?:\.\d+)?)/i);
    if (numbered && !/\b(?:books|volumes|vols|parts)\b/i.test(raw.split(/[-–—:]/).pop())) {
      number = parseFloat(numbered[1]);
    }
    var supplementary = /\b(?:books\s+\d+|companion|omnibus|collected|complete|prequel|novella|short stories)\b/i.test(raw)
      || !!numericRange;
    return { name: name || raw, key: (name || raw).toLocaleLowerCase(), number: number, supplementary: supplementary };
  }

  function makeButton(label, glyph) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'anpb-author-rail__arrow';
    button.setAttribute('aria-label', label);
    button.textContent = glyph;
    return button;
  }

  function upgrade(root) {
    if (root.dataset.anpbAuthorReady === 'true') return;
    var fallback = root.querySelector('.anpb-author-fallback');
    if (!fallback) return;
    var books = Array.prototype.slice.call(fallback.querySelectorAll('li.anpb-author-book'));
    if (!books.length) return;

    var groups = new Map();
    books.forEach(function (book) {
      var info = describeSeries(book.getAttribute('data-anpb-series'));
      var explicitNumber = Number(book.getAttribute('data-anpb-book-number'));
      if (Number.isFinite(explicitNumber) && explicitNumber > 0 && !info.supplementary) {
        info.number = explicitNumber;
      }
      var group = groups.get(info.key);
      if (!group) {
        group = { name: info.name, key: info.key, items: [] };
        groups.set(info.key, group);
      }
      group.items.push({
        book: book,
        title: book.getAttribute('data-anpb-book-title') || '',
        number: info.number,
        supplementary: info.supplementary
      });
    });

    var ordered = Array.from(groups.values()).sort(function (a, b) {
      if (a.key === '__standalone__') return 1;
      if (b.key === '__standalone__') return -1;
      return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    });
    var output = document.createElement('div');
    output.className = 'anpb-author-rails';

    ordered.forEach(function (group, index) {
      group.items.sort(function (a, b) {
        var aRank = a.supplementary ? 2 : a.number === null ? 1 : 0;
        var bRank = b.supplementary ? 2 : b.number === null ? 1 : 0;
        if (aRank !== bRank) return aRank - bRank;
        if (aRank === 0 && a.number !== b.number) return a.number - b.number;
        // Prefer the ordinary edition when a book number has multiple editions.
        var aSpecial = /anniversary|collector|special edition|limited edition/i.test(a.title);
        var bSpecial = /anniversary|collector|special edition|limited edition/i.test(b.title);
        if (aSpecial !== bSpecial) return aSpecial ? 1 : -1;
        return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true });
      });
      var rail = document.createElement('section');
      rail.className = 'anpb-author-rail';
      var header = document.createElement('div');
      header.className = 'anpb-author-rail__header';
      var heading = document.createElement('h2');
      heading.className = 'anpb-author-rail__heading';
      heading.textContent = group.name;
      var track = document.createElement('ul');
      track.className = 'anpb-author-rail__track';
      track.id = 'anpb-author-track-' + index + '-' + (root.closest('.shopify-section')?.id || 'collection');
      track.setAttribute('aria-label', group.name + ' books');
      group.items.forEach(function (item) {
        item.book.classList.remove('grid__item');
        track.appendChild(item.book);
      });
      var controls = document.createElement('div');
      controls.className = 'anpb-author-rail__controls';
      var previous = makeButton('Previous books in ' + group.name, '‹');
      var next = makeButton('Next books in ' + group.name, '›');
      previous.setAttribute('aria-controls', track.id);
      next.setAttribute('aria-controls', track.id);
      controls.append(previous, next);
      header.append(heading, controls);
      rail.append(header, track);
      output.appendChild(rail);

      function syncButtons() {
        var max = track.scrollWidth - track.clientWidth;
        controls.hidden = max <= 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      }
      function move(direction) {
        var firstBook = track.querySelector('.anpb-author-book');
        var step = firstBook ? firstBook.getBoundingClientRect().width + 16 : track.clientWidth * .8;
        track.scrollBy({ left: step * direction * Math.max(1, Math.floor(track.clientWidth / step)), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', syncButtons, { passive: true });
      window.addEventListener('resize', syncButtons, { passive: true });
      requestAnimationFrame(syncButtons);
    });
    fallback.replaceWith(output);
    root.dataset.anpbAuthorReady = 'true';
  }

  function boot(target) {
    (target || document).querySelectorAll('[data-anpb-author-series]').forEach(upgrade);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
